module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/logo-aoj-th-70b5183bd0253fa94488af79d6904d9e.svg";